export default function HotWedgeSection() {
  return (
    <section className="py-16 md:py-20 bg-gray-950 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <span className="text-green-400 text-xs font-black uppercase tracking-[0.2em]">
              Tecnologia
            </span>
            <h2 className="text-3xl md:text-4xl font-black uppercase mt-3 mb-6 leading-tight">
              Máquinas de Cunha Quente
            </h2>
            <div className="space-y-4 text-gray-300 text-sm leading-relaxed">
              <p>
                A soldagem por cunha quente é o método mais utilizado e confiável para união de geomembranas termoplásticas em campo. O princípio é simples e eficiente: uma cunha metálica aquecida é inserida entre duas camadas sobrepostas do material, fundindo as superfícies internas de forma controlada.
              </p>
              <p>
                Imediatamente após a fusão, rolos de pressão comprimem as camadas amolecidas, criando uma solda homogênea e de alta resistência mecânica. O resultado é uma costura contínua com propriedades equivalentes às do material original.
              </p>
              <p>
                Este processo garante uniformidade térmica ao longo de toda a largura da solda, essencial para a integridade da barreira impermeabilizante em aplicações críticas como aterros sanitários, reservatórios e contenção de resíduos industriais.
              </p>
              <p>
                As máquinas de cunha quente operam com controle digital de temperatura e velocidade regulável, permitindo adaptação precisa a diferentes espessuras e tipos de geomembrana. A SoldaGeo oferece modelos com potências de 800W a 2100W para atender desde pequenas obras até projetos de grande escala.
              </p>
            </div>
            <div className="grid grid-cols-2 gap-4 mt-8">
              {[
                { icon: 'ri-temp-hot-line', label: 'Temperatura Controlada', desc: 'Até 500°C com precisão digital' },
                { icon: 'ri-speed-line', label: 'Velocidade Regulável', desc: 'De 0,5 a 9 m/min' },
                { icon: 'ri-stack-line', label: 'Espessura Ampla', desc: 'Materiais de 500 a 3000 mic' },
                { icon: 'ri-shield-check-line', label: 'Solda Homogênea', desc: 'Resistência igual ao material base' },
              ].map((item) => (
                <div key={item.label} className="flex items-start gap-3 p-3 rounded-xl bg-white/5 border border-white/10">
                  <div className="w-8 h-8 flex items-center justify-center bg-green-500/20 rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-green-400 text-sm`} />
                  </div>
                  <div>
                    <p className="text-white text-xs font-black uppercase tracking-wide">{item.label}</p>
                    <p className="text-gray-400 text-xs mt-0.5">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Close%20up%20detail%20shot%20of%20industrial%20hot%20wedge%20welding%20machine%20heating%20element%20on%20black%20HDPE%20geomembrane%20liner%2C%20glowing%20orange%20metal%20wedge%20between%20two%20layers%2C%20professional%20welding%20seam%20detail%2C%20dark%20moody%20industrial%20lighting%2C%20texture%20of%20melted%20plastic%2C%20precision%20engineering%20aesthetic%2C%20shallow%20depth%20of%20field&width=900&height=1100&seq=hot-wedge-detail-01&orientation=portrait"
              alt="Detalhe da cunha quente em operação sobre geomembrana PEAD"
              className="w-full h-auto rounded-2xl object-cover"
            />
            <div className="absolute -bottom-4 -left-4 bg-green-500 text-white px-5 py-3 rounded-xl">
              <p className="text-xs font-black uppercase tracking-wider">Tecnologia Suíça & Nacional</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}